import { createElementFromHTML, getOffset, smoothScrollTo } from '../../js/helper';

class DetailHandler {
    constructor (options) {
        this.initContent = options.initContent;
        this.$loader = createElementFromHTML(options.$loader);

        // used for history
        this.defaultUri = window.location.href;
        this.defaultTitle = document.title;

        // element which opens the detail page (often a link)
        this.$handle = null;

        this.$detail = undefined; // DOM Node of the detail page

        this.hasParentInvertedDesign = document.querySelector('.siteheader.is--inverted');

        this.$header = document.querySelector('[data-header="root"]');

        this.$productSupportResultsFilterBar = document.querySelector('.product-support-form__results-filter-bar');
        this.setHistory('list-overview', this.defaultUri, this.defaultTitle);

        this.bindHistoryEvents();
    }

    bindHistoryEvents () {
        window.addEventListener('popstate', () => {
            if (history.state !== null && history.state.category !== null && history.state.category === 'result') {
                if (history.state.pageType === 'list-overview') {
                    this.closeDetail();
                }

                if (history.state.pageType === 'list-detail') {
                    this.showDetail(this.$handle);
                }
            } else {
                this.closeDetail();
            }
        });
    }

    bindCloseEvent ($detail) {
        const $closeButton = $detail.querySelector('[data-overlay="close"]');

        if ($closeButton) {
            $closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeDetail();
            });
        }
    }

    /**
     *
     * @param {DOM Element} $handle - Element to which you will go when closing "overlay",
     *                                can be an anchor with url
     * @param {String} uri - url with for detail page
     */
    showDetail ($handle, uri) {
        if ($handle) {
            this.$handle = $handle;
            uri = (uri !== undefined) ? uri : this.$handle.getAttribute('href');

            if (this.$loader) {
                this.$handle.appendChild(this.$loader);
            }

            // set &xhr=1 as cache key to prevent browser showing ajax response
            fetch(uri + '&xhr=1', {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(response => {
                return response.text();
            }).then(resultText => {
                this.$detail = createElementFromHTML(resultText);
                const $sitemain = document.querySelector('.sitemain');

                if ($sitemain) {
                    this.handlePageInvertState(true);
                    window.scrolling = false;
                    // add ajax result as first child to sitemain
                    $sitemain.prepend(this.$detail);
                    $sitemain.classList.add('has--detail');

                    if (this.$loader) {
                        this.$handle.removeChild(this.$loader);
                    }

                    let title = '';
                    const $title = this.$detail.querySelector('[itemprop="title"]');
                    if ($title) {
                        title = $title.getAttribute('content');
                    }

                    this.setHistory('list-detail', uri, title);

                    this.bindCloseEvent(this.$detail);

                    if (typeof this.initContent === 'function') {
                        this.initContent(this.$detail);
                    } else {
                        import('../../pages/product-support/product-support-page').then(() => {
                            window.initSupportContent(this.$detail);
                        });
                    }

                    const $productResultItem = $sitemain.querySelector('.product-support-result');
                    let productResultItemTop = parseInt($productResultItem.getBoundingClientRect().top + window.scrollY);

                    if (this.$header) {
                        productResultItemTop = productResultItemTop - this.$header.offsetHeight;
                    }
                    smoothScrollTo(0, productResultItemTop, 500);
                }

                const dealerLocatorButton = document.querySelector('[data-dealer="container"]');
                if (dealerLocatorButton) {
                    dealerLocatorButton.classList.add('is--page-hidden');
                }

                const dealerContactButton = document.querySelector('[data-contact="container"]');
                if (dealerContactButton) {
                    dealerContactButton.classList.remove('is--page-hidden');
                }
            });
        }
    }

    closeDetail () {
        if (this.$handle && this.$detail) {
            const $sitemain = document.querySelector('.sitemain');
            // remove details from site main
            $sitemain.removeChild(this.$detail);
            this.$detail = undefined;
            $sitemain.classList.remove('has--detail');

            this.handlePageInvertState(false);

            let filterBarHeight = 0;
            if (this.$productSupportResultsFilterBar) {
                filterBarHeight = this.$productSupportResultsFilterBar.offsetHeight + 15;
            }
            const handlePosition = getOffset(this.$handle); // get back to where we were :)

            const positionTop = handlePosition.top - filterBarHeight;

            smoothScrollTo(0, positionTop, 500);

            this.setHistory('list-overview', this.defaultUri, this.defaultTitle, true);

            const dealerLocatorButton = document.querySelector('[data-dealer="container"]');
            if (dealerLocatorButton) {
                dealerLocatorButton.classList.remove('is--page-hidden');
            }

            const dealerContactButton = document.querySelector('[data-contact="container"]');
            if (dealerContactButton) {
                dealerContactButton.classList.add('is--page-hidden');
            }

            setTimeout(() => {
                const $productResultsPreviewContainer = document.querySelector('.product-support-form-results-container');
                if ($productResultsPreviewContainer) {
                    $productResultsPreviewContainer.classList.remove('is--sticky');
                }
            }, 500);
        }
    }

    setHistory (type, uri, title, replace = false) {
        const historyObj = {
            category: 'result',
            pageType: type
        };

        document.title = title;
        if (replace === true) {
            history.replaceState(historyObj, title, uri);
        } else {
            history.pushState(historyObj, title, uri);
        }
    }

    /**
     * remove invert design on detail page and add invert design back to parent,
     * if it was in invert mode before
     */
    handlePageInvertState (isDetailActive) {
        const $pageHeader = document.querySelector('[data-header="root"]');

        if ($pageHeader) {
            if (isDetailActive) {
                $pageHeader.classList.remove('is--inverted');
            } else {
                if (this.hasParentInvertedDesign) {
                    $pageHeader.classList.add('is--inverted');
                }
            }
        }
    }
}

export { DetailHandler };
